import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonProfileSection = {
	id: number;
	section_type: number;
	section_type_label: string;
	title: string;
	subtitle: string;
	description: string;
};

export const getPersonProfileSectionsById = (
	id: number
): Promise<DRFListResponseWrapper<PersonProfileSection[]>> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonProfileSectionsById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/profile_sections/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
